import { useTranslator } from "components/Translator"
import { Card, CardContent } from "components/Card"
import { Avatar } from "components/Avatar"
import { Text } from "components/Text"
import { PlanPresentation } from "domains/plan/PlanPresentation"
import Markdown from "react-markdown"
import { getImageSrc } from "components/Image"
import { Button } from "components/Button"
import { RequireLogin } from "components/RequireLogin"
import cx from "classnames"

export const PlanCard = ({
  plan,
  color,
  onSelect,
  isSelected,
  godfather,
  busy,
  disabled,
  requireLogin,
}) => {
  const translator = useTranslator()

  const [price] = plan.prices

  const cta = (
    <Button
      type="button"
      onClick={onSelect}
      fullWidth
      color={color === "primary" ? "secondary" : "primary"}
      busy={busy}
      disabled={disabled}
    >
      {translator.trans("PlanCard.cta", null, "components")}
    </Button>
  )

  return (
    <div
      className={cx("rounded-lg grid", {
        "ring-2": isSelected,
        "focus:ring-secondary-light ring-secondary-default":
          color === "secondary",
        "focus:ring-primary-light ring-primary-default": color === "primary",
      })}
    >
      <Card spacing="small">
        <div className="flex flex-col h-full">
          {godfather && price.discountedPrice ? (
            <CardContent className="bg-primary-lighter">
              <div className="flex items-center space-x-2">
                <div className="shrink-0">
                  <Avatar
                    size="xsmall"
                    src={
                      godfather.imageFile
                        ? getImageSrc(godfather.imageFile, "w40")
                        : null
                    }
                    alt=""
                  />
                </div>
                <div className="grow">
                  <Text variant="body2">
                    <Markdown>
                      {translator.trans(
                        "club.plan.index.godfather",
                        { name: godfather.fullName },
                        "pages",
                      )}
                    </Markdown>
                  </Text>
                </div>
              </div>
            </CardContent>
          ) : null}
          <CardContent>
            <div className="space-y-4">
              <PlanPresentation plan={plan} color={color} />
              <Text tag="p" variant="body2" className="text-center">
                {plan.description}
              </Text>
            </div>
          </CardContent>
          <CardContent className="mt-auto">
            {requireLogin ? <RequireLogin>{cta}</RequireLogin> : cta}
          </CardContent>
        </div>
      </Card>
    </div>
  )
}
